import { FC } from 'react';

const TripBuilderGetPdfStyles: FC = () => {
  return (
    <style>{`
.tbp-modal {
  max-width: 900px;
  width: 95vw;
}

.tbp-modal .modal-content {
  max-height: 70vh;
  overflow-y: auto;
  padding-top: 8px;
}

.tbp-root {
  --tbp-flight-accent: #8dd5dc;
  --tbp-hotel-accent: #8dd5dc;
  --tbp-warm: #9b4d4d;
  --tbp-tag-room-bg: #dff4f8;
  --tbp-tag-room-text: #3d8fa0;
  --tbp-tag-board-bg: #e7f6ec;
  --tbp-tag-board-text: #4f8a62;
  --tbp-tag-cxl-bg: #faf0e8;
  --tbp-tag-cxl-text: #9a6b45;
  color: #1f1f1f;
}

.tbp-root-rtl .tbp-section-label {
  text-align: right;
}

.tbp-section {
  margin-bottom: 28px;
  direction: ltr;
}

.tbp-section:last-child {
  margin-bottom: 0;
}

.tbp-section-label {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}


.tbp-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tbp-flight-section {
  margin-top: 20px;
  margin-bottom: 13px;
}

.tbp-flight-row-title {
  margin-bottom: 10px;
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #8b949c;
}

.tbp-flight-card {
  display: flex;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  padding: 18px 19px;
  border: 1px solid var(--tbp-flight-accent);
  border-radius: 11px;
  background: #e7eef4;
  box-sizing: border-box;
}

.tbp-flight-card-no-price .tbp-flight-main {
  padding-inline-end: 4px;
}

.tbp-flight-card-no-price .tbp-flight-row-labels span:last-child,
.tbp-flight-card-no-price .tbp-flight-row-codes > span:last-child,
.tbp-flight-card-no-price .tbp-flight-row-times span:last-child,
.tbp-flight-card-no-price .tbp-flight-row-meta span:last-child {
  padding-inline-end: 2px;
}

.tbp-flight-left {
  flex: 1;
  min-width: 0;
}

.tbp-flight-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 86px minmax(0, 1fr);
  grid-template-rows: auto auto auto auto;
  column-gap: 14px;
  row-gap: 2px;
  align-items: center;
}

.tbp-flight-row-labels,
.tbp-flight-row-codes,
.tbp-flight-row-times,
.tbp-flight-row-meta {
  display: contents;
}

.tbp-flight-row-labels span {
  font-size: 0.54rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #8b949c;
}

.tbp-flight-row-labels span:first-child {
  grid-column: 1;
  grid-row: 1;
}

.tbp-flight-row-labels span:last-child {
  grid-column: 3;
  grid-row: 1;
  justify-self: end;
  text-align: right;
}

.tbp-flight-row-codes > span:first-child,
.tbp-flight-row-codes > span:last-child {
  font-size: clamp(1.4rem, 2.5vw, 1.88rem);
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.01em;
  color: #1f1f1f;
}

.tbp-flight-row-codes > span:first-child {
  grid-column: 1;
  grid-row: 2;
  padding-top: 2px;
}

.tbp-flight-row-codes > span:last-child {
  grid-column: 3;
  grid-row: 2;
  justify-self: end;
  padding-top: 2px;
}

.tbp-flight-arrow {
  grid-column: 2;
  grid-row: 2 / 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  align-self: end;
  width: 100%;
  padding-bottom: 5px;
}

.tbp-flight-arrow-icon {
  font-size: 2rem;
  line-height: 1;
  color: var(--tbp-flight-accent);
}

.tbp-flight-arrow-line {
  position: relative;
  width: 100%;
  height: 1px;
  background: var(--tbp-flight-accent);
}

.tbp-flight-arrow-line::before,
.tbp-flight-arrow-line::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--tbp-flight-accent);
  transform: translateY(-50%);
}

.tbp-flight-arrow-line::before {
  left: 0;
}

.tbp-flight-arrow-line::after {
  right: 0;
}

.tbp-flight-duration {
  font-size: 0.59rem;
  font-weight: 400;
  line-height: 1.2;
  color: #8b949c;
  white-space: nowrap;
  padding-top: 2px;
}

.tbp-flight-row-times span {
  font-size: 1.08rem;
  font-weight: 400;
  line-height: 1.1;
  color: var(--tbp-flight-accent);
}

.tbp-flight-row-times span:first-child {
  grid-column: 1;
  grid-row: 3;
  padding-top: 3px;
}

.tbp-flight-row-times span:last-child {
  grid-column: 3;
  grid-row: 3;
  justify-self: end;
  padding-top: 3px;
}

.tbp-flight-row-meta span {
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.35;
  color: #8b949c;
}

.tbp-flight-row-meta span:first-child {
  grid-column: 1;
  grid-row: 4;
  padding-top: 6px;
}

.tbp-flight-row-meta span:last-child {
  grid-column: 3;
  grid-row: 4;
  justify-self: end;
  text-align: right;
  padding-top: 6px;
}

.tbp-flight-row-meta span:only-child {
  grid-column: 1;
  justify-self: start;
  text-align: left;
}

.tbp-flight-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 10px;
  flex: 0 0 auto;
  min-width: 58px;
}

.tbp-flight-price {
  font-size: 0.76rem;
  font-weight: 500;
  line-height: 1.2;
  color: #1f1f1f;
  white-space: nowrap;
}

.tbp-price-amount {
  display: inline-flex;
  align-items: baseline;
  direction: ltr;
  gap: 4px;
  white-space: nowrap;
}

.tbp-price-currency {
  font: inherit;
  font-size: 0.8em;
  line-height: inherit;
  color: inherit;
}

.tbp-price-value {
  font: inherit;
  line-height: inherit;
  color: inherit;
}

.tbp-destination-block {
  margin-bottom: 0;
  border: 1px solid #e7e7e7;
  border-radius: 13px;
  overflow: hidden;
  background: #fff;
  page-break-inside: avoid;
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
}

.tbp-destination-separator {
  position: relative;
  height: 26px;
  margin-left: calc(16px + 46px + 11px + 11px);
}

.tbp-destination-separator::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #e7e7e7;
}

.tbp-destination-separator span {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #8b949c;
  font-size: 0.75rem;
  line-height: 1;
  background: #fff;
  padding: 0 1px;
}

.tbp-destination {
  display: flex;
  align-items: center;
  gap: 13px;
  width: 100%;
  padding: 13px 16px;
  border: 0;
  border-bottom: 1px solid #e7e7e7;
  border-radius: 0;
  background: #fff;
  box-sizing: border-box;
}

.tbp-destination-divider {
  height: 1px;
  background: #e7e7e7;
}

.tbp-destination-left {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
  flex: 1;
}

.tbp-destination-img {
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  border-radius: 8px;
  object-fit: cover;
  background: #edf2f5;
}

.tbp-destination-text {
  min-width: 0;
}

.tbp-destination-city {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.15;
  color: #222;
}

.tbp-destination-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  border: 1px solid #222;
  border-radius: 50%;
  font-size: 0.62rem;
  font-weight: 500;
  line-height: 1;
}

.tbp-destination-meta {
  margin-top: 3px;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.35;
  color: #8b949c;
}

.tbp-option-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 14px 16px;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
  box-sizing: border-box;
}

.tbp-option-card-img {
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  object-fit: cover;
  background: #edf2f5;
}

.tbp-option-card-img-empty {
  background: #edf2f5;
}

.tbp-option-card-left {
  flex: 1;
  min-width: 0;
}

.tbp-option-card-name {
  margin-bottom: 8px;
  font-size: 1.12rem;
  font-weight: 500;
  line-height: 1.2;
  color: #222;
}

.tbp-option-rating {
  margin-bottom: 8px;
}

.tbp-option-tags {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
}

.tbp-option-room-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.tbp-option-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 500;
  line-height: 1.2;
  text-transform: capitalize;
}

.tbp-option-tag-room {
  background: var(--tbp-tag-room-bg);
  color: var(--tbp-tag-room-text);
}

.tbp-option-tag-board {
  background: var(--tbp-tag-board-bg);
  color: var(--tbp-tag-board-text);
}

.tbp-option-tag-cxl {
  background: var(--tbp-tag-cxl-bg);
  color: var(--tbp-tag-cxl-text);
}

.tbp-option-tag-cxl-danger {
  background: #ef4444;
  color: #fff;
}

.tbp-option-tag-cxl-success {
  background: #366e34;
  color: #fff;
}

.tbp-option-meta {
  margin-bottom: 4px;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1.3;
  color: #8b949c;
}

.tbp-option-card-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  flex: 0 0 auto;
  min-width: 72px;
  padding-top: 2px;
}

.tbp-option-price {
  font-size: 1.44rem;
  font-weight: 500;
  line-height: 1;
  color: #222;
  white-space: nowrap;
}

.tbp-option-price .tbp-price-currency,
.tbp-option-price .tbp-price-value {
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
}

.tbp-option-price .tbp-price-currency {
  font-size: 0.8em;
}

.tbp-option-price .tbp-price-value {
  font-size: inherit;
}

.tbp-option-price-sub {
  margin-top: 4px;
  font-size: 0.58rem;
  font-weight: 400;
  line-height: 1.2;
  color: #8b949c;
  white-space: nowrap;
}

.tbp-total {
  margin-top: 24px;
  padding-top: 20px;
  text-align: center;
}

.tbp-total-label {
  display: block;
  margin-bottom: 8px;
  font-size: 0.62rem;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #8b949c;
}

.tbp-total-amount {
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  direction: ltr;
  gap: 4px;
  font-size: 2rem;
  font-weight: 500;
  line-height: 1;
  color: #222;
}

.tbp-total-amount .tbp-price-currency,
.tbp-total-amount .tbp-price-value {
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
}

.tbp-total-amount .tbp-price-currency {
  font-size: 0.8em;
}

.tbp-total-amount .tbp-price-value {
  font-size: inherit;
}

.tbp-total-currency {
  font-size: 1.1rem;
  font-weight: 500;
  color: #222;
}

.tbp-total-value {
  font-size: 2rem;
  font-weight: 500;
  line-height: 1;
  color: #222;
}

.tbp-route-map {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  margin: 0 auto;
  border-radius: 11px;
  border: 1px solid #e7e7e7;
}

.tbp-route-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
  padding: 12px 16px;
  border-radius: 11px;
  background: var(--tbp-tag-cxl-bg);
}

.tbp-route-summary-label {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.3;
  color: #222;
}

.tbp-route-summary-arrow {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1;
  color: #8b949c;
}

    `}</style>
  );
};

export default TripBuilderGetPdfStyles;
